import theme from "@/theme";

const DraftSvg = () => (
  <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M17.4193 10.0833V7.17567C17.4193 6.68983 17.2259 6.22325 16.8821 5.8795L14.2898 3.28717C13.946 2.94342 13.4794 2.75 12.9936 2.75H6.41927C5.40635 2.75 4.58594 3.57042 4.58594 4.58333V17.4167C4.58594 18.4296 5.40635 19.25 6.41927 19.25H10.0859"
      stroke={theme.palette.custom.mainBlue}
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M17.4193 7.33333H13.7526C13.2466 7.33333 12.8359 6.92267 12.8359 6.41667V2.75"
      stroke={theme.palette.custom.mainBlue}
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M15.7178 18.9814L18.9811 15.718C19.3396 15.3596 19.3396 14.7794 18.9811 14.4219L17.5273 12.968C17.1689 12.6096 16.5886 12.6096 16.2311 12.968L12.9678 16.2314C12.7955 16.4037 12.6992 16.6365 12.6992 16.8794V19.2499H15.0697C15.3126 19.2499 15.5455 19.1537 15.7178 18.9814Z"
      stroke={theme.palette.custom.mainBlue}
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);
export default DraftSvg;
